import { useTranslations } from '@vocab/react';
import { ButtonLink, IconStatistics } from 'braid-design-system';

import translations from './.vocab';
import { NudgeBanner } from './NudgeBanner';

const PROFILE_UPDATE_URL = '/profile/me';

export const NudgeProfileUpdateBanner = () => {
  const { t } = useTranslations(translations);

  return (
    <NudgeBanner
      title={t('YOUR_NEXT_JOB_COULD_BE_ONE_UPDATE_AWAY')}
      description={t('GIVING_PROFILE_QUICK_UPDATE_CAN_HELP')}
      actionButton={
        <ButtonLink
          href={PROFILE_UPDATE_URL}
          icon={<IconStatistics />}
          tone="brandAccent"
        >
          {t('UPDATE_PROFILE')}
        </ButtonLink>
      }
    />
  );
};
